import { t } from '@lingui/core/macro';

import type {
  KPINotificationType,
  PageMetaNotificationNameType,
} from '@/api/settings/settingsType';

type CampaignKPINameType =
  | 'campaign-total-visits'
  | 'campaign-audience-visits'
  | 'campaign-engaged-companies'
  | 'campaign-pipeline-influenced'
  | 'campaign-closed-won-influenced'
  | 'campaign-visit-efficiency'
  | 'campaign-roms-pipeline-influenced';

export const campaignGoalKPIs = (): Partial<
  Record<PageMetaNotificationNameType, KPINotificationType<CampaignKPINameType>[]>
> => ({
  campaign: [
    { value: 'campaign-total-visits', label: t`Total Visits`, allowsAudience: false },
    {
      value: 'campaign-visit-efficiency',
      label: t`Audience Visit Efficiency`,
      allowsAudience: true,
    },
    {
      value: 'campaign-engaged-companies',
      label: t`Audience Engaged Companies`,
      allowsAudience: true,
    },
    {
      value: 'campaign-roms-pipeline-influenced',
      label: t`Audience ROMS Pipeline Influence`,
      allowsAudience: true,
    },
    {
      value: 'campaign-closed-won-influenced',
      label: t`Audience Closed Won Influence`,
      allowsAudience: true,
    },
  ],
  campaigns: [
    { value: 'campaign-total-visits', label: t`Total Visits`, allowsAudience: false },
    {
      value: 'campaign-audience-visits',
      label: t`Audience Visits`,
      allowsAudience: true,
    },
    {
      value: 'campaign-engaged-companies',
      label: t`Audience Engaged Companies`,
      allowsAudience: true,
    },
    {
      value: 'campaign-pipeline-influenced',
      label: t`Audience Pipeline Influence`,
      allowsAudience: true,
    },
    {
      value: 'campaign-closed-won-influenced',
      label: t`Audience Closed Won Influence`,
      allowsAudience: true,
    },
  ],
});
